import React from 'react';

import {Spinner} from 'components/spinner';
import {useTableReportParameters} from 'components/table-report/hooks/use-table-report-parameters';
import {TableReport} from 'components/table-report/table-report';
import {ITableReportProps} from 'components/table-report/table-report-types';

export const TableReportPage = ({entityName, docId, templateCode}: ITableReportProps) => {
    const {passedParameters} = useTableReportParameters();
    const pageKey = `${docId ?? 'null'}-${templateCode}-${passedParameters?.DRILL_ID ? 'drill' : 'root'}`;

    return (
        <>
            {templateCode ? (
                <TableReport
                    key={pageKey}
                    entityName={entityName}
                    docId={docId}
                    templateCode={templateCode}
                />
            ) : <Spinner />}
        </>
    );
};
